export default {
    isProcessedUploadedSuccessfull: [],
    processPayroll: [],
    closedPayroll: [],
    getAllCreatePayroll: [],
    getAllLogHours: [],
    getAllOvertime: [],
    getAllEarnings: [],
    getAllDeductions: [],
    getAllLoans: [],
    hoursRenderedDataLoaded: false,
    hoursRenderedDataLoading: false,
    hoursRenderedDataError: null,
    uploadedLogHours: [],
    uploadedOvertimeHours: [],
    uploadedEarnings: [],
    uploadedDeductions: [],
    uploadedLoans: [],
    generatereports: []
}
